import type { ReactNode } from 'react';

export type ProfileIconName =
  | 'person' | 'party' | 'calendar' | 'education' | 'location' | 'pin' | 'group'
  | 'parliament' | 'clock' | 'database' | 'expense-document' | 'proposal-document' | 'amendment-check' | 'share' | 'save';

const paths: Record<ProfileIconName, ReactNode> = {
  person: <><circle cx="12" cy="7" r="3.5" /><path d="M4 21v-2a8 8 0 0 1 16 0v2Z" /></>,
  party: <path d="m12 3 2.7 5.5 6.3.9-4.5 4.3 1.1 6.2L12 17l-5.6 2.9 1.1-6.2L3 9.4l6.3-.9L12 3Z" />,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M7 3v4M17 3v4M3 10h18M8 14h2v2H8zM14 14h2v2h-2z" /></>,
  education: <><path d="m2 9 10-5 10 5-10 5L2 9Z" /><path d="M6 11v5c3.5 3 8.5 3 12 0v-5M22 9v7" /></>,
  location: <><path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></>,
  pin: <><path d="M12 21s7-7.2 7-12a7 7 0 1 0-14 0c0 4.8 7 12 7 12Z" /><circle cx="12" cy="9" r="2" /></>,
  group: <><circle cx="9" cy="8" r="3" /><path d="M3 20a6 6 0 0 1 12 0M16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 5" /></>,
  parliament: <path d="M3 9 12 4l9 5H3Zm2 2h3v8H5zm6 0h3v8h-3zm6 0h3v8h-3zM3 21h18" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  database: <><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" /></>,
  'expense-document': <path d="M6 3h9l4 4v14H6zM15 3v5h4M9 12h7M9 16h7" />,
  'proposal-document': <path d="M6 3h9l4 4v14H6zM15 3v5h4M9 12h7M9 16h5" />,
  'amendment-check': <><rect x="4" y="4" width="16" height="16" rx="2" /><path d="m8 12 3 3 6-7" /></>,
  share: <><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="m8.7 10.7 6.6-4.4m-6.6 9 6.6 4.2" /></>,
  save: <path d="M6 3h12v18l-6-4-6 4z" />,
};

export function ProfileIcon({ name, size = 20, className }: { name: ProfileIconName; size?: number; className?: string }) {
  return <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{paths[name]}</svg>;
}
